<template>
  <div>
    <vxe-grid
      ref="table"
      size="small"
      row-id="selectionCode"
      cell-class-name="align-top"
      resizable
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :checkbox-config="{ highlight: true, reserve: true }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @cell-click="cellClick"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:displayImage="{ row }">
        <el-image
          :src="row.displayImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[
            row.displayImageUrl || '/image/static/img/nopic.jpg',
          ]"
          style="width: 60px; height: 60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 60px; height: 60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                v-show="opt.show == undefined ? true : opt.show(row)"
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:displaySampleName="{ row }">
        <TableLabel :value="row.sampleStyleNo" />
        <TableLabel :value="row.expoSampleBrand" />
        <TableLabel :value="row.expoSampleName" />
      </template>
      <template v-slot:displaySelectionBy="{ row }">
        <TableLabel :value="row.selectionByName" />
        <TableLabel :value="row.selectionLocalTime" />
      </template>
      <template v-slot:displaySelectionRemark="{ row }">
        <div v-html="row.tskDescription || ''" />
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>

    <Dialog
      v-if="chooseSampleVisible"
      :visible.sync="chooseSampleVisible"
      type="radio"
      @confirm="sampleConfirm"
      :confirm-on-close="false"
    />
  </div>
</template>
<script>
import { format } from '@/libs/util.number.js'
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
import TableLabel from './label.vue'
import Dialog from './dialog.vue'
export default {
  mixins: [TableAutoHeight, EditLoading],
  components: { TableLabel, Dialog },
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    expoMeetingStatus: { type: String, default: '' },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
      chooseSampleVisible: false,
      selectionCode: '',
      format: (n) => format(n),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    getHeight() {
      const tableHeight = window.innerHeight - 300
      this.tableHeight = tableHeight < 560 ? 560 : tableHeight
    },
    optCommand({ opt, data }) {
      const { menuType } = opt
      if (!menuType) return

      switch (menuType) {
        case 'detail':
        case 'arrange':
        case 'edit':
          this.$emit('openEdit', { type: menuType, data })
          break
        case 'delete':
          this.del(data)
          break
        case 'binding':
          this.chooseSampleVisible = true
          this.selectionCode = data.selectionCode
          break
        default:
          console.error('menuType configuration error: ', menuType)
      }
    },
    async del({ selectionCode }) {
      const confirm = await this.$confirm(
        this.$l('confirm_delSelection') || '是否要删除该展品？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      this.loadingOpen()
      const res = await this.$api
        .expoMeetingSelectionDelApi({ selectionCode })
        .catch(() => false)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.clearCheckboxRow()
      this.$emit('reload')
    },
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkbox-change', [])
    },
    cellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['checkbox', 'defaultImage', 'col-opt']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)

      const data = $table
        .getCheckboxRecords(true)
        .concat($table.getCheckboxReserveRecords(true))
      this.$emit('checkbox-change', data)
    },
    async sampleConfirm(data) {
      if (!data) return
      const confirm = await this.$confirm(
        this.$l('tips_bind_sample') || '是否绑定选中的样品？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      const params = {
        sampleCode: data.sampleCode || data.fabricCode,
        selectionCode: this.selectionCode,
      }

      this.loadingOpen()
      const res = await this.$api
        .expoMeetingSelectionBindSamplesApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.chooseSampleVisible = false
      this.selectionCode = false
      this.$emit('reload')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-toolbar {
    height: initial;
    margin-bottom: 12px;
  }
}
</style>
